import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartSegment = () => {
  return (
    <g>
      <path d="M5.693 1.084a.75.75 0 0 1-.373.992 6.5 6.5 0 1 0 8.6 8.614.75.75 0 0 1 1.364.621A8 8 0 1 1 4.7.71a.75.75 0 0 1 .993.374zm1.626.324A1.636 1.636 0 0 1 9.174.016l.273.043a8.012 8.012 0 0 1 6.543 6.867l.008.101.002.078c0 .874-.709 1.583-1.583 1.583H9.053a1.75 1.75 0 0 1-1.75-1.75V1.632c0-.075.006-.15.016-.224zm1.636.092a.133.133 0 0 0-.15.113l-.002.019v5.306c0 .138.112.25.25.25h5.364c.046 0 .083-.037.085-.064l-.04-.283A6.502 6.502 0 0 0 9.2 1.539z" />
    </g>
  );
};

export default withIcon(IconChartSegment);
